import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { trackMarketplaceEvent } from '../lib/track';
import { HomePage } from '../pages/home';
import { SearchPage } from '../pages/search';
import { SalonPage } from '../pages/salon';
import { LoginPage } from '../pages/login';
import { MyBookingsPage } from '../pages/my-bookings';
import { ProfilePage } from '../pages/profile';
import { BookingCompletePage } from '../pages/booking-complete';

/** One PAGE_VIEW analytics ping per client-side navigation (operator console). */
function PageViewTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    trackMarketplaceEvent('PAGE_VIEW');
  }, [pathname]);
  return null;
}

export function App() {
  return (
    <>
      <PageViewTracker />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/salon/:subdomain" element={<SalonPage />} />
        <Route path="/login" element={<LoginPage />} />
      {/* Magic-link emails point here (MarketplaceAuthService builds
          `${base}/magic-link?token=`). LoginPage already consumes `?token`,
          so alias it rather than rename the minted URL — links already sent
          to inboxes keep working. */}
        <Route path="/magic-link" element={<LoginPage />} />
        <Route path="/me/bookings" element={<MyBookingsPage />} />
        <Route path="/me/profile" element={<ProfilePage />} />
      {/* Stripe async-payment return URL (Pix/Bancontact). Reads the
          `payment_intent` query param and polls the booking-intent status. */}
        <Route path="/booking/complete" element={<BookingCompletePage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </>
  );
}

export default App;
